const ruleAdm = Object.freeze({
  id: 'adm',
  title: 'Administrador',
  permissions: ['read', 'write', 'delete', 'list','filter']
})

const ruleCadastro = Object.freeze({
  id: 'Cadastro',
  title: 'Cadastro',
  permissions: ['read', 'write', 'delete', 'list','filter']
})

const ruleConsulta = Object.freeze({
  id: 'Consulta',
  title: 'Consulta',
  permissions: ['read', 'list','filter']  
})
const customerStatus = Object.freeze({
  ATV: 'ATV', // Ativo
  SPS: 'SPS', // Suspenso
  DEL: 'DEL', // Deletado
})

export const rules = Object.freeze({
  ruleAdm,
  ruleCadastro,
  ruleConsulta,
  customerStatus
})
